/**
 * util cookie module
 * @class UtilCookie
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.cookie.get('id');
 */
class UtilCookie {
  constructor() {
    this.cookie = {};
    this.domainArr = document.domain ? document.domain.split('.') : [];
    this.domainArrLen = this.domainArr.length;
    this.domain = this.domainArr.slice(this.domainArrLen - 2, this.domainArrLen).join('.');
    this.isSupported = typeof document.cookie === 'string';
  }

  /**
   * set cookie
   * @param {String} name cookie name
   * @param {String|Number} value cookie value
   * @param {String} domain cookie domain
   * @param {String} path cookie path
   * @param {Number} hour cookie expire time
   */
  set(name, value, domain, path, hour) {
    let expire;
    if (hour) {
      expire = new Date();
      expire.setTime(expire.getTime() + (3600000 * hour));
    }
    document.cookie = `${name}=${value}; ${expire ? `expires=${expire.toGMTString()}; ` : ''}path=${path
      || '/'}; domain=${domain || this.domain};`;
  }

  /**
   * get cookie
   * @param {String} name cookie name
   */
  get(name) {
    const r = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`);
    const m = document.cookie.match(r);
    // eslint-disable-next-line no-mixed-operators
    return (m && m[1]) || '';
  }

  /**
   * delete cookie
   * @param {String} name cookie name
   * @param {String} domain cookie domain
   * @param {String} path cookie path
   */
  del(name, domain, path) {
    document.cookie = `${name}=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=${path || '/'}; domain=${domain
      || this.domain};`;
  }

  /**
   * clear cookie
   */
  clear() {
    const m = document.cookie.match(/\w+=[^;]*/g);
    if (m) {
      for (let i = 0, l = m.length; i < l; i += 1) {
        this.del(m[i].split('=')[0]);
      }
    }
  }
}

export default new UtilCookie();
